import { FC } from 'react';
import { AutoComplete, AutoCompleteProps } from 'antd';
import { kebabCase } from 'lodash';
import Input from '../input/Input';
import { StyledAutocomplete, StyledSearchIcon } from './styles';

interface Props extends Omit<AutoCompleteProps, 'placeholder'> {
    inputPlaceholder?: string;
    error?: string;
}

const SearchBar: FC<Props> = (props) => {
    const { inputPlaceholder, ...autoCompleteProps } = props;
    const size = props.size ? props.size : 'middle';

    return (
        <StyledAutocomplete error={props.error}>
            <AutoComplete getPopupContainer={(trigger: any) => trigger.parentElement} allowClear {...autoCompleteProps}>
                <Input
                    size={size}
                    bordered={false}
                    placeholder={inputPlaceholder ?? ''}
                    suffix={<StyledSearchIcon />}
                    data-testid={`${kebabCase(inputPlaceholder ?? 'default')}-search-bar`}
                />
            </AutoComplete>
        </StyledAutocomplete>
    );
};

export const { Option } = AutoComplete;
export default SearchBar;
